import styled from 'styled-components'

export const Container = styled.footer`
  width: 100%;
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.colors.secondary};
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  margin-top: auto;
`

export const Text = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text};
  text-align: center;
  line-height: 1.5;
  opacity: 0.8;
`
